module.exports = __webpack_public_path__ + "img/md.a60a1301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/md.jpg
// module id = 2211
// module chunks = 137